import styled from "styled-components"

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0 1.5rem;
  align-items: center;
  justify-content: center;
  .switch-label{
    font-size: 12px;
  }
`

export const InfoWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  width: fit-content;
  align-items: center;
  justify-content: center;
  
  .title {
    font-size: 12px;
    color: #424242;
  }
`

export const SwitchWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  width: fit-content;
  align-items: center;
  justify-content: center;
  .switch-label{
    font-size: 10px;
    text-transform: capitalize;
  }
`
